function BadStatus() {
  return (
    <button disabled class="outline outline-red-700 bg-red-100 text-red-700 font-bold py-1 px-5 rounded-full">
      Low
    </button>
  );
}

export default BadStatus;
